// eslint-disable-next-line import/prefer-default-export
export function zeroFill(number: number, width: number): string {
    const numberString = number.toString();
    return numberString.length >= width ? numberString : new Array(width - numberString.length + 1).join('0') + numberString;
}
